import DataTable from '@/components/features/data-table/DataTable';
import { toTitleCase } from '@/helpers/shadcn/utils';
import { useCustomerList } from '@/services/Customer/customerService';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const CustomersTable = () => {
  const navigate = useNavigate();

  const columns = [
    {
      columnKey: 'name',
      header: 'CUSTOMER NAME',
      cellData: ctx => {
        return (
          <span
            style={{
              cursor: 'pointer',
              color: '#66A5E7',
              textDecoration: 'none'
            }}
            onClick={() =>
              navigate(`/profile/customer/${ctx.row.original.sapId}`)
            }>
            {ctx.row.original.name || '-'}
          </span>
        );
      }
    },
    {
      columnKey: 'sapId',
      header: 'SAP ID',
      cellData: ctx => ctx.row.original.sapId || '-'
    },
    {
      columnKey: 'email',
      header: 'EMAIL',
      cellData: ctx => ctx.row.original.email || '-'
    },
    {
      columnKey: 'phone',
      header: 'PHONE',
      cellData: ctx => ctx.row.original.phone || '-'
    },
    {
      columnKey: 'numberOfStores',
      header: '# OF STORES',
      cellData: ctx => ctx.row.original.numberOfStores || '-'
    },
    {
      columnKey: 'oktaStatus',
      header: 'STATUS',
      cellData: ctx => {
        return (
          <span
            style={{
              color:
                ctx.row.original.oktaStatus === 'No Order in 30+ days'
                  ? '#E46666'
                  : ''
            }}>
            {ctx.row.original.oktaStatus
              ? toTitleCase(ctx.row.original.oktaStatus.replace('_', ' '))
              : '-'}
          </span>
        );
      }
    },
    {
      columnKey: 'idpId',
      header: 'IDP ID',
      cellData: ctx => ctx.row.original.idpId || '-'
    }
  ];

  return (
    <>
      <div className='relative'>
        <DataTable
          tableHeader='Customers'
          columns={columns}
          isDark
          showColumnFilters={true}
          onSettingsClicked={() => alert('Settings clicked')}
          selection='multiple'
          pageSize={10}
          enableSorting={true}
          fetchFunction={useCustomerList}
          downloadFileName='customerview_MX_data.csv'
        />
      </div>
    </>
  );
};

export default CustomersTable;
